import { Component, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { SVGIcon, checkOutlineIcon, minusOutlineIcon } from "@progress/kendo-svg-icons";

@Component({
    selector: "detail-kendo-grid",
    templateUrl: "./detail-grid.html"
})
export class DetailKendoGridComponent implements OnInit {
    @Input() dataSource: any[];
    @Input() dataKey: string = 'id';
    @Input() pageSize: number = 5;
    @Input() pageable: boolean = true;
    @Input() hideHeader: boolean = true;
    @Input() resizable: boolean = false;
    @Input() columns: any[];
    @Input() pathUrl: string;
    @Input() buttonTemplates!: { [key: string]: TemplateRef<any> };

    checkOutlineIcon: SVGIcon = checkOutlineIcon;
    minusOutlineIcon: SVGIcon = minusOutlineIcon;

    ngOnInit(): void {
    }

}
